/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { useCallback, useRef } from 'react';

const useDebouncedCallback = (callback, delay = 500) => {
  const timeoutRef = useRef();
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  return useCallback((...args) => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      if (typeof callbackRef.current === 'function') {
        callbackRef.current(...args);
      }
    }, delay);
  }, [delay]);
};

export default useDebouncedCallback;
